import React from "react";
import { ValType } from "../../utils/ValidationFunctions";
import Form from "../../common/forms/Form";
import FormInput from "../../common/forms/FormInput";
import ErrorBanner from "../../common/forms/ErrorBanner";

import RegistHeader from "./RegistHeader";

import styles from "./p-register.module.scss";
import formStyles from "../../common/forms/g-formInput.module.scss";

type Props = {
  pass: string;
  confirm_pass: string;
  submit_handler: () => void;
  input_handler: (value: string, name: string) => void;
  backward_handler: () => void;
  error?: string;
};

const RegistPasswordForm: React.FC<Props> = ({
  pass,
  confirm_pass,
  submit_handler,
  input_handler,
  backward_handler,
  error,
}) => {
  return (
    <div className={styles["p-register__box"]}>
      <RegistHeader
        showLogo={false}
        title={"パスワードの作成"}
        message={
          "パスワードは半角英数字8文字以上、大文字、小文字、数字、特殊記号(!@#$%^&*)をそれぞれ1文字以上含んで作成してください"
        }
      />
      <div className={styles["p-register__form"]}>
        <Form
          handler={submit_handler}
          button_id="next_button"
          button_text="次へ"
          button_class={formStyles["g-button"]}
        >
          <div className={styles["p-register__form__pass-error"]}>
            <ErrorBanner
              warn={error !== undefined && error !== "" ? true : false}
              message={error}
            />
          </div>
          <div className={formStyles["g-form__wrapper"]}>
            <FormInput
              type="passwordBeforeLabel"
              label="パスワード"
              name="sonic_pass"
              val_type={ValType.PasswordFormat}
              placeholder="パスワード"
              id="sonic_pass"
              handler={input_handler}
              style_class={formStyles["g-form__input"]}
              label_class={formStyles["g-form__label"]}
              initial_value={pass}
            />
          </div>
          <div className={formStyles["g-form__wrapper"]}>
            <FormInput
              type="passwordBeforeLabel"
              label="パスワード（確認用）"
              name="sonic_pass_confirm"
              val_type={ValType.PasswordFormat}
              placeholder="パスワード確認"
              id="sonic_pass_confirm"
              handler={input_handler}
              style_class={formStyles["g-form__input"]}
              label_class={formStyles["g-form__label"]}
              initial_value={confirm_pass}
            />
          </div>
        </Form>
        <button
          type="button"
          className={styles["p-register__form__button"]}
          onClick={backward_handler}
        >
          戻る
        </button>
      </div>
    </div>
  );
};

export default RegistPasswordForm;
